const reviews = [
  {
    name: 'James W.',
    role: 'General Contractor',
    text: 'The team was incredibly professional and fast. They showed up on time, completed the parking lot resurfacing ahead of schedule, and left the site spotless. If you need commercial asphalt paving in NJ, these are your guys.',
  },
  {
    name: 'Linda R.',
    role: 'Property Manager',
    text: 'NJ Commercial Asphalt handled a large lot for one of our commercial properties. Their crew was courteous, efficient, and the quality of the work was excellent. We will absolutely be calling them again.',
  },
  {
    name: 'David S.',
    role: 'Business Owner',
    text: 'I called them on a Tuesday and they had a crew out by Thursday. Fast, clean, and very professional. The asphalt looks great and the price was fair. Highly recommend for any commercial paving needs.',
  },
  {
    name: 'Maria T.',
    role: 'Facilities Director',
    text: 'Outstanding service from start to finish. They handled a complex multi-phase parking lot project across our campus and managed everything smoothly. Very impressed with their organization and attention to detail.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-white" id="testimonials">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center border-b-2 border-gray-900 pb-6 mb-12">
          <h2
            className="text-3xl md:text-4xl font-extrabold uppercase text-gray-900"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            What People Are Saying
          </h2>
        </div>

        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12 text-base leading-relaxed">
          At NJ Commercial Asphalt Paving, customer satisfaction drives everything we do. Our clients across New Jersey consistently praise our attention to detail, honest communication, and long-lasting results. Whether it&apos;s commercial paving, parking lot repair, or asphalt maintenance, we treat every property like our own.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="border border-gray-200 rounded-lg p-6 flex flex-col gap-4 hover:shadow-md transition-shadow"
            >
              <div className="flex justify-center">
                <img
                  src="https://www.advancedasphaltca.com/wp-content/uploads/2025/06/quote.png"
                  alt="Quote"
                  className="w-12 h-auto"
                />
              </div>
              <div className="text-center">
                <p
                  className="font-bold text-gray-900 text-base"
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {r.name}
                </p>
                <p className="text-xs text-gray-500 uppercase font-semibold tracking-wide">
                  {r.role}
                </p>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed flex-1">{r.text}</p>
              <div className="flex justify-center gap-1 text-yellow-400 text-lg">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
